/* ta-lottie-fx.js
   Product-page Lotties in the product's own colour:
   1. Fast Shipping timeline: the "Ordered" step pops and fills with the colour, a line of
      paint runs to "Packed", which pops and rings, then dashes keep moving toward "Delivered".
      Plays once, when the timeline scrolls into view.
   2. Squeeze to cart (off unless turned on in the snippet): tapping Add to cart squeezes
      a rope of the colour out of a tube, which drops onto the button.
   The Lottie files use placeholder colours (magenta = paint, cyan = shade) that are swapped
   for the product's colours before playing. Settings come from window.TAFX, written by
   snippets/ta-lottie-fx.liquid. Nothing animates for people who have reduced motion turned on.
*/
(function () {
  'use strict';
  var C = window.TAFX;
  if (!C || window.TAFX_READY) return;
  window.TAFX_READY = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toArr(hex) {
    hex = String(hex).replace('#', '');
    return [parseInt(hex.slice(0, 2), 16) / 255, parseInt(hex.slice(2, 4), 16) / 255, parseInt(hex.slice(4, 6), 16) / 255, 1];
  }
  var MAP = [[[1, 0, 1], toArr(C.colour)], [[0, 1, 1], toArr(C.shade)]];

  function recolour(o) {
    if (Array.isArray(o)) { o.forEach(recolour); return; }
    if (!o || typeof o !== 'object') return;
    if (o.c && o.c.a === 0 && Array.isArray(o.c.k)) {
      for (var i = 0; i < MAP.length; i++) {
        var s = MAP[i][0], k = o.c.k;
        if (Math.abs(k[0] - s[0]) < 0.01 && Math.abs(k[1] - s[1]) < 0.01 && Math.abs(k[2] - s[2]) < 0.01) {
          o.c.k = MAP[i][1].slice();
          break;
        }
      }
    }
    for (var key in o) { if (Object.prototype.hasOwnProperty.call(o, key)) recolour(o[key]); }
  }

  /* One Lottie player per page: reuse the one the cap animation loads, if it got there first */
  var libPromise = null;
  function lib() {
    if (window.lottie) return Promise.resolve(window.lottie);
    if (libPromise) return libPromise;
    libPromise = new Promise(function (resolve, reject) {
      var s = document.querySelector('script[data-lottie-web]');
      if (!s) {
        s = document.createElement('script');
        s.src = C.lottie;
        s.async = true;
        s.setAttribute('data-lottie-web', '');
        document.head.appendChild(s);
      }
      s.addEventListener('load', function () { resolve(window.lottie); });
      s.addEventListener('error', reject);
      if (window.lottie) resolve(window.lottie);
    });
    return libPromise;
  }

  var cache = {};
  function data(url) {
    if (!cache[url]) cache[url] = fetch(url).then(function (r) { return r.json(); });
    return cache[url].then(function (d) { var x = JSON.parse(JSON.stringify(d)); recolour(x); return x; });
  }

  function make(el, url, opts) {
    return Promise.all([lib(), data(url)]).then(function (a) {
      var o = { container: el, renderer: 'svg', loop: false, autoplay: false, animationData: a[1] };
      if (opts) for (var k in opts) o[k] = opts[k];
      return a[0].loadAnimation(o);
    });
  }

  /* ---------- 1. Fast Shipping timeline ---------- */
  function initShip() {
    var tl = document.querySelector('.ta-reassurance .ta-timeline');
    if (!tl) return;
    var steps = tl.querySelectorAll('.ta-step');
    if (steps.length < 3) return;
    var icons = [].map.call(steps, function (s) { return s.querySelector('.ta-step-icon'); });
    if (icons.some(function (i) { return !i; })) return;

    tl.classList.add('tafx-ship');
    tl.style.setProperty('--tafx-c', C.shipColour || C.colour);
    tl.style.setProperty('--tafx-ink', C.shipInk || '#1a1a1a');

    var line = document.createElement('div');
    line.className = 'tafx-line';
    line.setAttribute('aria-hidden', 'true');
    tl.appendChild(line);
    var nodes = [0, 1].map(function () {
      var d = document.createElement('div');
      d.className = 'tafx-node';
      d.setAttribute('aria-hidden', 'true');
      tl.appendChild(d);
      return d;
    });

    function place() {
      var r = tl.getBoundingClientRect();
      var c = icons.map(function (i) {
        var b = i.getBoundingClientRect();
        return { x: b.left + b.width / 2 - r.left, y: b.top + b.height / 2 - r.top };
      });
      line.style.left = c[0].x + 'px';
      line.style.width = (c[2].x - c[0].x) + 'px';
      line.style.top = (c[0].y - 12) + 'px';
      nodes.forEach(function (n, i) {
        n.style.left = (c[i].x - 48) + 'px';
        n.style.top = (c[i].y - 48) + 'px';
      });
    }
    place();
    if ('ResizeObserver' in window) new ResizeObserver(place).observe(tl);

    if (reduce) {
      line.classList.add('tafx-line--static');
      steps[0].classList.add('tafx-fill');
      steps[1].classList.add('tafx-ring');
      return;
    }

    function run() {
      Promise.all([
        make(line, C.line, { rendererSettings: { preserveAspectRatio: 'none' } }),
        make(nodes[0], C.node),
        make(nodes[1], C.node)
      ]).then(function (a) {
        var L = a[0], N0 = a[1], N1 = a[2];
        steps[0].classList.add('tafx-fill');
        N0.play();
        L.addEventListener('complete', function once() {
          L.removeEventListener('complete', once);
          L.loop = true;
          L.playSegments([40, 100], true);
        });
        L.playSegments([0, 40], true);
        setTimeout(function () { steps[1].classList.add('tafx-ring'); N1.play(); }, 1150);
      }).catch(function () {
        line.classList.add('tafx-line--static');
        steps[0].classList.add('tafx-fill');
        steps[1].classList.add('tafx-ring');
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); run(); }
      }, { threshold: 0.6 });
      io.observe(tl);
    } else {
      run();
    }
  }

  /* ---------- 2. Squeeze to cart ---------- */
  function initSqueeze() {
    if (reduce || !C.squeeze) return;
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
    idle(function () { lib(); data(C.squeeze); });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] button[name="add"]');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      if (!window.lottie) return;
      var r = btn.getBoundingClientRect();
      var w = 96, h = 144;
      if (r.top < h - 10) return;
      var box = document.createElement('div');
      box.className = 'tafx-squeeze';
      box.setAttribute('aria-hidden', 'true');
      box.style.left = Math.round(r.left + r.width / 2 - w / 2) + 'px';
      box.style.top = Math.round(r.top - h + 16) + 'px';
      document.body.appendChild(box);
      make(box, C.squeeze).then(function (a) {
        a.addEventListener('complete', function () { a.destroy(); box.remove(); });
        a.play();
      }).catch(function () { box.remove(); });
    }, true);
  }

  function start() { initShip(); initSqueeze(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();